import { Button, message } from "antd";
import { FormDialog, FormLayout, FormItem, Input } from "@formily/antd";
import { createSchemaField } from "@formily/react";
import { message as messageService } from "@/services";
import ColleagueSelect from "./ColleagueSelect";

const schema = {
  type: "object",
  properties: {
    colleague: {
      type: "string",
      title: "推送至",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "ColleagueSelect",
      "x-component-props": "{{{token}}}",
    },
    content: {
      type: "string",
      title: "办理意见",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input.TextArea",
    },
  },
};

const SchemaField = createSchemaField({
  components: {
    FormItem,
    Input,
    ColleagueSelect,
  },
});

function MessagePushButton({
  type,
  size = "default",
  token,
  messageId,
  callback,
}) {
  return (
    <FormDialog.Portal>
      <Button
        type={type}
        size={size}
        onClick={() => {
          FormDialog({ title: "推送" }, "modal-dialog", () => {
            return (
              <FormLayout labelCol={6} wrapperCol={14}>
                <SchemaField schema={schema} scope={{ token }} />
              </FormLayout>
            );
          })
            .forConfirm((payload, next) => {
              messageService
                .pushMessage(messageId, payload.values, token)
                .then((res) => {
                  message.success("推送成功");
                  callback(Date.now());
                })
                .catch((err) => {
                  message.error(err.message || err);
                })
                .finally(() => {
                  next(payload);
                });
            })
            .open();
        }}
      >
        推送
      </Button>
    </FormDialog.Portal>
  );
}

export default MessagePushButton;
